<template>
  <v-snackbar
    app
    color="transparent elevation-0 mr-n2 "
    right
    v-if="msg"
    top
    :value="true"
    :timeout="-1"
  >
    <v-alert
      transition="slide-x-reverse-transition"
      v-show="expand"
      class="white"
      border="left"
      :type="type"
      elevation="8"
    >
      {{ msg }}
    </v-alert>
  </v-snackbar>
</template>

<script>
export default {
  props: ["message"],
  data: () => ({
    type: "success",
    expand: false,
    msg: "",
    timer: null,
  }),
  methods: {
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    endAndStartTimer() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.expand = false;
        this.msg = "";
      }, this.type === 'success' ? 5000: 9000);
    },
  },
  created() {
    if (this.message) {
      this.flash(this.message);
    }

    this.$bus.$on("flash", async (message) => {
      this.expand = false;
      await this.timeout(300);
      this.endAndStartTimer();
      this.expand = true;
      this.msg = message.msg;
      this.type = message.type;
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
